function storage(type) {

    const api = type == 'local' ? 'localStorage' : 'sessionStorage';
    return {
        set(key, value) {
            if (typeof value === 'object' && value !== null) value = JSON.stringify(value);
            window[api].setItem(key, value);
        }
        ,
        get(key) {
            var value = window[api].getItem(key);
            if(value == null || value == '') return value;
            let tmp = null;
            try {
                tmp = JSON.parse(value);
            } catch(e) {
                
            } 

            return tmp ? tmp : value;
        }
        ,
        remove(key) {
            window[api].removeItem(key);
        }
    }
}

export default storage;

